import api from '../config/api';

const getFavorites = async (userId) => {
  try {
    const response = await api.get(`/favorites/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const addToFavorites = async (favoriteData) => {
  try {
    // API'ye gönderilecek veriyi hazırla
    const phoneModelsJson = favoriteData.phone_models.map(model => ({
      phone_model_id: model.id,
      brand: model.brand,
      model_name: model.model_name
    }));

    const requestBody = {
      user_id: favoriteData.user_id,
      product_id: favoriteData.product_id,
      phone_models: phoneModelsJson
    };

    const response = await api.post('/favorites/add', requestBody);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const removeFromFavorites = async (userId, productId) => {
  try {
    const response = await api.delete('/favorites/remove', {
      data: {
        user_id: userId,
        product_id: productId
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export {
  getFavorites,
  addToFavorites,
  removeFromFavorites
};